import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {helpers} from "../lib"

/**
 * Use Check  groupName  Present
 */
export default (imageId: number) => {
  const { imageTypes } = useSelector((state) => state.typesList);

  return useMemo(() => {
    const imageType = helpers.getListItemForId(imageTypes,imageId);
    if(imageType && imageId)
        return imageType.name;          
    else 
        return "image"
  }, [imageTypes,imageId]);
};